import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { ADD_DIMENSION } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const ActivateDimension = ({
  sourceAccountId, targetAccountId, assessmentSection, dimension, growl, fetchData,
}) => {
  const [addDimension] = useMutation(ADD_DIMENSION);
  const intl = useIntl();

  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock-open"
        label={intl.formatMessage(messages.add)}
        onClick={async () => {
          await addDimension({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
                assessmentSection,
                dimension,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.addDimensionSuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({ severity: 'error', detail: intl.formatMessage(messages.addDimensionError), sticky: true });
            });
        }}
      />
    </>
  );
};

ActivateDimension.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  assessmentSection: PropTypes.string.isRequired,
  dimension: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(ActivateDimension);
